angular.module('dpw.services')
    .constant('dpwEvents', {
        hMenusUpdate: 'hMenusUpdate',
        topMenusUpdated: 'topMenusUpdated'
    }).constant('platformTypes', [
    {id: 'MobileIOS', text: 'Mobile/iOS'},
    {id: 'MobileAndroid', text: 'Mobile/Android'},
    {id: 'MobileOther', text: 'Mobile/Other'},
    {id: 'DesktopWindows', text: 'Desktop/Windows'},
    {id: 'DesktopMac', text: 'Desktop/Mac'},
    {id: 'DesktopOther', text: 'Desktop/Other'},
    {id: 'BrowserBased', text: 'Browser-based'},
    {id: 'ServerWeb', text: 'Server/Web'},
    {id: 'ServerBot', text: 'Server/Bot'},
    {id: 'ServerOther', text: 'Server-only (No UI)'},
    {id: 'MessagingNotification', text: 'Messaging Notification App'},
    {id: 'ProfileOnly', text: 'Profile Only'}
]).constant('deprecatedPlatformTypes', [
    {id: 'Embedded', text: 'Embedded'},
    {id: 'Other', text: 'Other'}
]).constant('keyStatusAlias', {
    'Unblocking': 'Waiting for unblocking'
}).constant('conversationTypes', {
    EVERYONE: 'Everyone',
    TEAM: 'Team',
    GROUP: 'Group',
    PERSONAL: 'Personal',
    DIRECT: 'Direct'
}).constant('historyFieldMap', {
    application: {
        type: 'Platform type',
        name: 'Application name',
        apiPlanId: 'Usage plan',
        redirectURIs: 'redirectUris'
    },
    'app-profile': 'App profile',
    'app-profile-revision': 'Profile revision',
    'default-parameter': 'Default parameter',
    'organization-parameter': 'Organization parameter',
    'application-parameter': 'Application parameter',
    'application-attribute': 'App attribute',
    'key': 'Application client ID',
    organization: {
        rcAccountId: 'Extension ID',
        name: 'Organization name',
        type: 'Organization type',
        contactPhone: 'Production Number',
        apiPlanId: 'Usage plan'
    }
}).constant('appKeyStatus', {
    Initial: 'Initial',
    Pending: 'Pending',
    Active: 'Active',
    Blocked: 'Blocked',
    Suspended: 'Suspended',
    Removed: 'Removed',
    Unblocking: 'Unblocking'
}).constant('keyStatusTransitions', {
    'Initial': ['Pending'],
    'Active': ['Blocked', 'Suspended'],
    'Suspended': ['Active', 'Blocked'],
    'Blocked': ['Active', 'Unblocking'],
    'Pending': ['Active', 'Blocked'],
    'Unblocking': ['Active', 'Blocked']
}).constant('allAppScopes', [
    'Private',
    'Public',
    'Internal'
]).constant('brands', {
    1210: 'RC US',
    3610: 'RC Canada',
    3710: 'RC UK',
    2010: 'RC EU',
    5010: 'RC AU',
    1250: 'RC FedRAMP',
    3420: 'AT&T',
    3460: 'AT&T',
    7310: 'TELUS',
    7710: 'BT',
    8010: 'Zoom',
    6010: 'Avaya',
    2020: 'Atos',
    2110: 'Alcatel',
    7010: 'Vodafone',
    2210: 'Verizon',
    4210: 'Ecotel',
    4610: 'Eastlink',
    4810: 'MCM',
    4710: 'Versatel',
    2030: 'Telekom (DT)',
    2040: 'Unify Office (DT/ATOS)',
    4910: 'Frontier',
    2050: 'Sunrise',
    5110: 'Charter SMB',
    5210: 'Charter Enterprise',
}).constant('sortedBrandIds', [
    "1210",
    "3610",
    "3710",
    "2010",
    "5010",
    "1250",
    "2110",
    "2020",
    "3420",
    "3460",
    "7310",
    "7710",
    "6010",
    "7010",
    "2210",
    "4210",
    "4610",
    "4810",
    "4710",
    "4910",
    "2030",
    "2040",
    "2050",
    "5110",
    "5210",
]).constant('brandsForAppGallery', {
    1210: 'RingCentral',
    3610: 'RingCentral',
    3710: 'RingCentral',
    5010: 'RingCentral',
    1250: 'RingCentral',
    3420: 'AT&T',
    7310: 'TELUS',
    7710: 'BT',
    6010: 'Avaya',
    2010: 'RingCentral',
    2020: 'Atos',
    2110: 'Alcatel',
    2210: 'Verizon',
    7010: 'Vodafone',
    4210: 'Ecotel',
    4810: 'MCM',
    4610: 'Eastlink',
    4710: 'Versatel',
    2030: 'Telekom (DT)',
    2040: 'Unify Office (DT/ATOS)',
    4910: 'Frontier',
    2050: 'Sunrise',
    5110: 'Charter SMB',
    5210: 'Charter Enterprise',
}).constant('rcBrandIds', [
    '1210',
    '3610',
    '3710',
    '2010',
    '5010',
    '1250'
]).constant('brandsForSettings', [
    {
        id: "RingCentral",
        value: [1210, 3610, 3710, 2010, 5010, 1250],
        checked: true,
        enabled: false
    },
    {
        id: "AT&T",
        value: [3420],
        checked: true,
        enabled: true
    },
    {
        id: "Avaya",
        value: [6010],
        checked: true,
        enabled: true
    },
    {
        id: "BT",
        value: [7710],
        checked: true,
        enabled: true
    },
    {
        id: "TELUS",
        value: [7310],
        checked: true,
        enabled: true
    },
    {
        id: "Atos",
        value: [2020],
        checked: true,
        enabled: true
    },
    {
        id: "Alcatel",
        value: [2110],
        checked: true,
        enabled: true
    },
    {
        id: "Verizon",
        value: [2210],
        checked: true,
        enabled: true
    },
    {
        id: "Vodafone",
        value: [7010],
        checked: true,
        enabled: true
    },
    {
        id: "Ecotel",
        value: [4210],
        checked: true,
        enabled: true
    },
    {
        id: "MCM",
        value: [4810],
        checked: true,
        enabled: true
    },
    {
        id: "Eastlink",
        value: [4610],
        checked: true,
        enabled: true
    },
    {
        id: "Versatel",
        value: [4710],
        checked: true,
        enabled: true
    },
    {
        id: "Telekom (DT)",
        value: [2030],
        checked: true,
        enabled: true
    },
    {
        id: "Unify Office (DT/ATOS)",
        value: [2040],
        checked: true,
        enabled: true
    },
    {
        id: "Frontier",
        value: [4910],
        checked: true,
        enabled: true
    },
    {
        id: "Sunrise",
        value: [2050],
        checked: true,
        enabled: true
    },
    {
        id: "Charter SMB",
        value: [5110],
        checked: true,
        enabled: true
    },
    {
        id: "Charter Enterprise",
        value: [5210],
        checked: true,
        enabled: true
    },
]).constant('partnerBrands', [
    {
        id: "3420",
        value: "AT&T"
    },
    {
        id: "3460",
        value: "AT&T"
    },
    {
        id: "7710",
        value: "BT"
    },
    {
        id: "7310",
        value: "TELUS"
    },
    {
        id: "6010",
        value: "Avaya"
    },
    {
        id: "2020",
        value: "Atos"
    },
    {
        id: "2110",
        value: "Alcatel"
    },
    {
        id: "2210",
        value: "Verizon"
    },
    {
        id: "7010",
        value: "Vodafone"
    },
    {
        id: "4210",
        value: "Ecotel"
    },
    {
        id: "4810",
        value: "MCM"
    },
    {
        id: "4610",
        value: "Eastlink"
    },
    {
        id: "4710",
        value: "Versatel"
    },
    {
        id: "2030",
        value: "Telekom (DT)"
    },
    {
        id: "2040",
        value: "Unify Office (DT/ATOS)"
    },
    {
        id: "4910",
        value: "Frontier"
    },
    {
        id: "2050",
        value: "Sunrise"
    },
    {
        id: "5110",
        value: "Charter SMB"
    },
    {
        id: "5210",
        value: "Charter Enterprise"
    },
    {
        id: "2000",
        value: "Rise I"
    },
    {
        id: "3000",
        value: "Rise A"
    }
]).constant('ATTBrands', {
    ATT: '3420',
    UB: '3460'
}).constant('countries', [
    {id: 39, code: 1, name: 'Canada'},
    {id: 224, code: 44, name: 'United Kingdom'},
    {id: 1, code: 1, name: 'United States'},
    {id: 15, code: 61, name: "Australia"},
    {id: 16, code: 43, name: 'Austria'},
    {id: 23, code: 32, name: 'Belgium'},
    {id: 57, code: 420, name: "Czech Republic"},
    {id: 58, code: 45, name: 'Denmark'},
    {id: 74, code: 358, name: 'Finland'},
    {id: 75, code: 33, name: 'France'},
    {id: 83, code: 49, name: 'Germany'},
    {id: 100, code: 852, name: 'Hong Kong'},
    {id: 103, code: 91, name: 'India'},
    {id: 107, code: 353, name: 'Ireland'},
    {id: 108, code: 972, name: "Israel"},
    {id: 109, code: 39, name: 'Italy'},
    {id: 128, code: 352, name: "Luxembourg"},
    {id: 133, code: 60, name: 'Malaysia'},
    {id: 143, code: 52, name: 'Mexico'},
    {id: 157, code: 31, name: 'Netherlands'},
    {id: 167, code: 47, name: 'Norway'},
    {id: 175, code: 63, name: 'Philippines'},
    {id: 177, code: 351, name: 'Portugal'},
    {id: 182, code: 40, name: "Romania"},
    {id: 188, code: 65, name: 'Singapore'},
    {id: 195, code: 34, name: 'Spain'},
    {id: 205, code: 46, name: 'Sweden'},
    {id: 206, code: 41, name: 'Switzerland'},
    {id: 208, code: 886, name: 'Taiwan'}
]).constant('defaultBrand', 1210)
    .constant('voidImageUrlPlaceHolder', 'NULL')
    .constant('defaultCountryId', 1)
    .constant('accessLevels', [
        'Basic',
        'Advanced',
        'Internal'
    ]).constant('orgTypes', [
    'Customer',
    'Free',
    'Test',
    'Native',
    'Developer'
]).constant('orgStatus', [
    'Active',
    'Deleted',
]).constant('partnerTypes', [
    '-',
    'Elite',
    'Premier',
    'Authorized'
]).constant('usagePlanLimits', [
    'heavy', 'medium', 'light', 'auth'
]).constant('apiGroupTypes', {
    'base': 'base',
    'extended': 'extended'
}).constant('apiRefEntries', {
    'baseUrl': '/api-reference',
    'entries': {
        'permissions': '/Application-Permissions',
        'rateLimits': '/Usage-Plan-Groups',
        'sms': '/SMS/createSMSMessage',
        'ringOut': '/RingOut/createRingOutCall',
        'fax': '/Fax/createFaxMessage'
    }
}).constant('adminAppStateTransitions', {
    'Active': ['Suspended', 'Blocked'],
    'Blocked': ['Active', 'Deleted'],
    'Suspended': ['Active', 'Blocked', 'Deleted'],
    'Deleted': ['Suspended']
}).constant('adminOrgStatusTransitions', {
    'Active': ['Deleted'],
    'Deleted': ['Active']
}).constant('allAppState', [
    {id: 'Active', name: 'Active'},
    {id: 'Blocked', name: 'Blocked'},
    {id: 'Suspended', name: 'Suspended'},
    {id: 'Deleted', name: 'Deleted'}
]).constant('appStatusShortNames', {
    'Active': 'Active',
    'Blocked': 'Blocked',
    'Suspended': 'Suspended',
    'Deleted': 'Deleted'
}).constant('validImageMimeTypes', [
    'image/jpeg',
    'image/png',
    'image/gif'
]).constant('tierIds', {
    free: ['4530']
}).constant('appProfileConstants', {
    appType: ["Bot", "Browser Extension", "Desktop Client", "Mobile App", "Native Integration", "Plugin", "Workflow",
        "Messaging Notification App", "Unknown"],
    mnaAppType: 'Messaging Notification App',
    appCategory: [
        "AI", "Analytics", "Audience Engagement","Automation", "Bots & Notifications", "Calendaring", "Certification", "Collaboration", "CRM", "Customer Support",
        "Developer Tools", "Education", "ERP", "Fax", "Financial Services", "Healthcare", "Labs", "Legal", "Marketing Automation",
        "Productivity", "Retail", "SMS", "Speech", "Storage", "Translation"
    ],
    appCategoryDisplayNames: {
        'Calendaring': 'Calendaring',
    },
    appPlatform: ['Cloud', 'Desktop', 'Mobile', 'Others'],
    appIndustry: [
        "Education", "Energy + Utilities", "Entertainment and Media", "Financial Services", "Government", "Healthcare",
        "High Tech", "Hospitality", "Manufacturing", "Non-Profit", "Professional Services", "Real Estate", "Retail",
        "Telecommunications", "Transportation", "Wholesale/Distribution", "Other"
    ],
    products: ["Glip", "Video", "Office", "Contact Center", "Engage Digital", "Engage Voice", "Meetings", "Service Web",
        "Webinar", "Events"],
    productDisplayNames: {
        'Office': 'Phone',
        'Glip': 'Message',
        "Engage Digital": 'RingCX Digital',
        "Engage Voice": 'RingCX Voice',
    }
})
    .constant('adminSiteEntries', {
        orgDetail: '/administration.html#/organization-info/{orgId}'
    })
    .constant('rcInternalUserIdentifier', {
        emailPatterns: [/^(.*)@(.*)\.?ringcentral\.com$/i, /^(.*)@(.*)\.?nordigy\.ru$/i, /^(.*)@(.*)\.?ab-soft\.net$/i]
    })
    .constant('validatePattern', {
        email: /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
        url: /^https?:\/\/.+$/i,
        phone: /^[-\d()\t +]+$/,
        https: /^https/i
    })
    .constant('partnerTypeLogos', {
        Blank: [],
        Elite: [
            {
                logo: '/assets/images/partner-logo/partner_elite_tran.png',
                svg: '/assets/images/partner-logo/partner_elite_tran.svg',
                png: '/assets/images/partner-logo/partner_elite_tran.png'
            },
            {
                logo: '/assets/images/partner-logo/partner_elite_dark.png',
                svg: '/assets/images/partner-logo/partner_elite_dark.svg',
                png: '/assets/images/partner-logo/partner_elite_dark.png'
            }],
        Premier: [
            {
                logo: '/assets/images/partner-logo/partner_premier_tran.png',
                svg: '/assets/images/partner-logo/partner_premier_tran.svg',
                png: '/assets/images/partner-logo/partner_premier_tran.png'
            },
            {
                logo: '/assets/images/partner-logo/partner_premier_dark.png',
                svg: '/assets/images/partner-logo/partner_premier_dark.svg',
                png: '/assets/images/partner-logo/partner_premier_dark.png'
            }],
        Authorized: [
            {
                logo: '/assets/images/partner-logo/partner_authorized_tran.png',
                svg: '/assets/images/partner-logo/partner_authorized_tran.svg',
                png: '/assets/images/partner-logo/partner_authorized_tran.png'
            },
            {
                logo: '/assets/images/partner-logo/partner_authorized_dark.png',
                svg: '/assets/images/partner-logo/partner_authorized_dark.svg',
                png: '/assets/images/partner-logo/partner_authorized_dark.png'
            }]
    })
    .constant('tutorialUrlPrefix', 'https://ringcentral-tutorials.github.io')
    .constant('myAcctAppsLinkStorage', 'my-account-apps-link')
    .constant('appGalleryH1TagMaxLength', 80)
    .constant('brandSlugMap', {
        1210: '',
        3420: 'office-at-hand',
        7310: 'telus-business-connect',
        7710: 'bt-cloud-work',
        6010: 'avaya-cloud-office',
        2020: 'unify-office',
        2110: 'rainbow-office',
        2210: 'ringcentral-with-verizon',
        7010: 'vodafone-business',
        4810: 'ringcentral-for-symphony',
        4210: 'ringcentral-mit-ecotel',
        4610: 'ringcentral-with-eastlink',
        4710: 'ringcentral-mit-1und1-connected-calls',
        2030: 'ringcentral-mit-telekom',
        2040: 'unifyoffice-telekom-mit-ringcentral',
        4910: 'frontier-plus-ringcentral',
        2050: 'ringcentral-with-sunrise'
    })
    .constant('UNIXStartTime', moment('1970-01-01T00:00:00.000+00:00'));
